<template>
  <th data-align="center" data-column-id="mnu" data-formatter="mnu" data-sortable="false" data-width="36px" title="Menu de opções" data-header-no-icon="true"></th>
</template>

<script>
export default {
  name: 'ContextMenuHeader'
}
</script>
